import React, {forwardRef, useEffect, useImperativeHandle, useMemo, useState} from "../../../../../__snowpack__/pkg/react.js";
import {Cascader, Col, Collapse, DatePicker, Form, Input, Radio, Row, Select, Spin, Switch, Tag} from "../../../../../__snowpack__/pkg/antd.js";
import {cascaderFilter, cascaderRender} from "../../../../components/BaseCascader/filterRenderMethod.js";
import {debounce, isArray} from "../../../../../__snowpack__/pkg/lodash.js";
import styled from "../../../../../__snowpack__/pkg/styled-components.js";
import {useCategoryRuleChannelModel} from "../../../../entities/product-shopee/shopeeBatch.js";
import {InputLimit} from "../../../../components/InputLimit.js";
import {TableStore} from "../../../../components/TableStore.js";
import {TableStoreLogo} from "../../../../components/TableStoreLogo.js";
import {Tip} from "../../../../components/Tip/index.js";
import {useBrands} from "../../../../entities/product-shopee/useBrands.js";
import {useCategories} from "../../../../entities/product-shopee/useCategories.js";
import {useCategoryAttributes} from "../../../../entities/product-shopee/useCategoryAttributes.js";
import {useShopsLogisticsMapModel} from "../../../../entities/product-shopee/useShopLogistics.js";
import {useShops} from "../../../../entities/useShops.js";
import {useOnMounted} from "../../../../lib/composition-api.js";
import {SyncButton} from "../../../../components/syncButton.js";
import {IconDown} from "../../../../../__snowpack__/pkg/@genieui-react/icon.js";
import {useIntl} from "../../../../../__snowpack__/pkg/react-intl.js";
import checked from "../assets/checked.png";
import unchecked from "../assets/unchecked.png";
import viewMoreSvg from "../assets/view-more.svg";
import RichTextEditor from "../../../../components/RichTextEditor/index.js";
import {useShopCountryModel, useCatrgoryInfoModel} from "../store.js";
import {SelectInput3} from "../../../../components/SelectInput3.js";
import moment from "../../../../../__snowpack__/pkg/moment-timezone.js";
import {TextQuantitative} from "../../../../components/TextQuantitative.js";
import {SelectInputQuantitative} from "../../../../components/SelectInputQuantitative.js";
import {useRequest} from "../../../../../__snowpack__/pkg/ahooks.js";
import request from "../../../../utils/request/index.js";
const {Option} = Select;
const {Panel} = Collapse;
const {useForm} = Form;
const {TextArea} = Input;
let desc = "";
const CascaderWrapper = (props) => {
  const {formatMessage} = useIntl();
  const {categoriesList, fetchData: fetchCategoriesList} = useCategories();
  useEffect(() => {
    if (props.countryCode) {
      fetchCategoriesList("SHOPEE_ID", props.countryCode);
    }
  }, [props.countryCode]);
  return /* @__PURE__ */ React.createElement(Cascader, {
    id: props.id,
    value: props.value,
    expandTrigger: "hover",
    fieldNames: {
      label: "name",
      value: "id"
    },
    disabled: !props.countryCode,
    showSearch: {filter: cascaderFilter, render: cascaderRender},
    placeholder: formatMessage({id: "selectCategories"}),
    options: categoriesList,
    onChange: (val) => {
      props.onChange && props.onChange(val);
    }
  });
};
export const dyItemsRender = (data, formatMessage) => {
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    span: "12"
  }, data.type === "TEXT" && /* @__PURE__ */ React.createElement(Form.Item, {
    name: `${data.attributeId}.productAttribute`,
    label: data.attributeName,
    rules: [{required: data.mandatory}]
  }, /* @__PURE__ */ React.createElement(Input, {
    placeholder: formatMessage({
      id: "pleaseEnter"
    })
  })), data.type === "TEXT_QUANTITATIVE" && /* @__PURE__ */ React.createElement(Form.Item, {
    name: `${data.attributeId}.productAttribute`,
    label: data.attributeName,
    rules: [
      {
        required: data.mandatory,
        message: formatMessage({id: "pleaseEnter"})
      }
    ]
  }, /* @__PURE__ */ React.createElement(TextQuantitative, {
    options: data?.attributeUnitList?.map((_2) => {
      return {
        value: _2,
        label: _2
      };
    }),
    placeholder: formatMessage({
      id: "pleaseEnter"
    })
  })), data.type === "SELECT" && /* @__PURE__ */ React.createElement(Form.Item, {
    name: `${data.attributeId}.productAttribute`,
    label: data.attributeName,
    rules: [
      {
        required: data.mandatory,
        message: formatMessage({id: "pleaseSelect"})
      }
    ]
  }, /* @__PURE__ */ React.createElement(Select, {
    className: "block-input-group block-input-group-handler",
    placeholder: formatMessage({
      id: "pleaseSelect"
    }),
    showSearch: true,
    optionFilterProp: "title"
  }, data.options.map((_2) => {
    const label = Object.keys(_2)[0];
    const value = _2[label];
    return /* @__PURE__ */ React.createElement(Option, {
      value,
      title: label
    }, label);
  }))), data.type === "SELECT_INPUT" && /* @__PURE__ */ React.createElement(Form.Item, {
    name: `${data.attributeId}.productAttribute`,
    label: data.attributeName,
    rules: [
      {
        required: data.mandatory,
        message: formatMessage({id: "pleaseSelect"})
      }
    ]
  }, /* @__PURE__ */ React.createElement(SelectInput3, {
    options: data.options.map((_2) => {
      const label = Object.keys(_2)[0];
      const value = _2[label];
      return {
        label,
        value
      };
    }),
    placeholder: formatMessage({
      id: "pleaseSelect"
    }),
    addAttributeValueMsg: formatMessage({
      id: "addAttributeValue"
    }),
    pleaseEnterMsg: formatMessage({
      id: "pleaseEnter"
    })
  })), data.type === "SELECT_INPUT_QUANTITATIVE" && /* @__PURE__ */ React.createElement(Form.Item, {
    name: `${data.attributeId}.productAttribute`,
    label: data.attributeName,
    rules: [
      {
        required: data.mandatory,
        message: formatMessage({id: "pleaseEnter"})
      }
    ]
  }, /* @__PURE__ */ React.createElement(SelectInputQuantitative, {
    unitOptions: data?.attributeUnitList?.map((_2) => {
      return {
        label: _2,
        value: _2
      };
    }),
    options: data.options.map((_2) => {
      const label = Object.keys(_2)[0];
      const value = _2[label];
      return {
        label,
        value
      };
    }),
    placeholder: formatMessage({
      id: "pleaseSelect"
    }),
    addAttributeValueMsg: formatMessage({
      id: "addAttributeValue"
    }),
    pleaseEnterMsg: formatMessage({
      id: "pleaseEnter"
    })
  })), data.type === "MULTI_SELECT" && /* @__PURE__ */ React.createElement(Form.Item, {
    name: `${data.attributeId}.productAttribute`,
    label: data.attributeName,
    rules: [
      {
        required: data.mandatory,
        message: formatMessage({id: "pleaseSelect"})
      },
      {
        type: "array",
        max: 5,
        message: formatMessage({
          id: "attributeTip"
        })
      }
    ]
  }, /* @__PURE__ */ React.createElement(Select, {
    mode: "multiple",
    className: "block-input-group block-input-group-handler",
    placeholder: formatMessage({
      id: "pleaseSelect"
    }),
    showSearch: true,
    optionFilterProp: "title"
  }, data.options.map((_2) => {
    const label = Object.keys(_2)[0];
    const value = _2[label];
    return /* @__PURE__ */ React.createElement(Option, {
      value,
      title: label
    }, label);
  }))), data.type === "MULTI_SELECT_INPUT" && /* @__PURE__ */ React.createElement(Form.Item, {
    name: `${data.attributeId}.productAttribute`,
    label: data.attributeName,
    rules: [
      {
        required: data.mandatory,
        message: formatMessage({id: "pleaseSelect"})
      },
      {
        type: "array",
        max: 5,
        message: formatMessage({
          id: "attributeTip"
        })
      }
    ]
  }, /* @__PURE__ */ React.createElement(SelectInput3, {
    mode: "multiple",
    options: data.options.map((_2) => {
      const label = Object.keys(_2)[0];
      const value = _2[label];
      return {
        label,
        value
      };
    }),
    placeholder: formatMessage({
      id: "pleaseSelect"
    }),
    addAttributeValueMsg: formatMessage({
      id: "addAttributeValue"
    }),
    pleaseEnterMsg: formatMessage({
      id: "pleaseEnter"
    })
  })), data.type === "DATE" && /* @__PURE__ */ React.createElement(Form.Item, {
    name: `${data.attributeId}.productAttribute`,
    label: data.attributeName,
    rules: [{required: data.mandatory}]
  }, /* @__PURE__ */ React.createElement(DatePicker, null)), ![
    "TEXT",
    "TEXT_QUANTITATIVE",
    "DATE",
    "SELECT",
    "SELECT_INPUT",
    "SELECT_INPUT_QUANTITATIVE",
    "MULTI_SELECT",
    "MULTI_SELECT_INPUT"
  ].includes(data.type) && /* @__PURE__ */ React.createElement("p", {
    style: {color: "red"}
  }, "\u6682\u4E0D\u652F\u6301", data.type, "\uFF0C\u8BF7\u9009\u62E9\u5176\u4ED6\u7C7B\u76EE")));
};
export const getCategoryAttributeValue = (attributeId, value, categoryAttributes) => {
  const item = categoryAttributes.find((_2) => _2.attributeId === attributeId);
  if (item && item.type === "TEXT") {
    return [
      {
        attribute_id: 0,
        value,
        unit: ""
      }
    ];
  }
  if (item && item.type === "TEXT_QUANTITATIVE") {
    const curValue = value;
    return [
      {
        attribute_id: 0,
        value: curValue.value,
        unit: curValue.unit
      }
    ];
  }
  if (item && item.type === "SELECT_INPUT_QUANTITATIVE") {
    const options = item.options;
    const selected = options.find((_2) => {
      const curLabel = Object.keys(_2)[0];
      const curValue = _2[curLabel];
      return curValue === value;
    });
    const selectedLabel = selected ? Object.keys(selected)[0] : value;
    const selectedValue = selected ? selected[selectedLabel] : 0;
    const selectedUnit = item.attributeUnitList.find((_2) => {
      if (selectedLabel.endsWith(_2)) {
        return _2;
      }
    });
    return [
      {
        attribute_id: selectedValue,
        value: selectedLabel.replace(selectedUnit, ""),
        unit: selectedUnit
      }
    ];
  }
  if (item && item.type === "DATE") {
    return [
      {
        attribute_id: 0,
        value: moment.isMoment(value) ? value.format("X").valueOf() : "",
        unit: ""
      }
    ];
  }
  if (item && ["SELECT", "SELECT_INPUT"].includes(item.type)) {
    const options = item.options;
    const selected = options.find((_2) => {
      const curLabel = Object.keys(_2)[0];
      const curValue = _2[curLabel];
      return curValue === value;
    });
    const selectedLabel = selected ? Object.keys(selected)[0] : value;
    const selectedValue = selected ? selected[selectedLabel] : 0;
    return [
      {
        attribute_id: selectedValue,
        value: selectedLabel,
        unit: ""
      }
    ];
  }
  if (item && ["MULTI_SELECT", "MULTI_SELECT_INPUT"].includes(item.type)) {
    const options = item.options;
    const itemInfo = item;
    const selectedList = value?.map((_2) => {
      const option = options.find((item2) => {
        const curLabel = Object.keys(item2)[0];
        const curValue = item2[curLabel];
        return _2 === curValue;
      });
      if (option) {
        return option;
      }
      return {
        [_2]: 0
      };
    }) || [];
    return selectedList.map((selected) => {
      const selectedLabel = Object.keys(selected)[0];
      const selectedValue = selected[selectedLabel];
      return {
        attribute_id: selectedValue,
        value: selectedLabel,
        unit: itemInfo.attributeUnitList ? itemInfo.attributeUnitList[0] : ""
      };
    });
  }
};
export const getCategoryAttributeFormValue = (attributeId, attribute, categoryAttributes) => {
  const item = categoryAttributes.find((_2) => _2.attributeId === attributeId);
  if (item && item.type === "TEXT") {
    return attribute[0]?.value;
  }
  if (item && item.type === "TEXT_QUANTITATIVE") {
    return {
      value: attribute[0]?.value,
      unit: attribute[0]?.unit
    };
  }
  if (item && item.type === "SELECT_INPUT_QUANTITATIVE") {
    if (attribute[0]?.attribute_id === 0) {
      return attribute[0]?.value + attribute[0]?.unit;
    }
    return attribute[0]?.attribute_id;
  }
  if (item && item.type === "DATE") {
    return moment(Number(attribute[0]?.value) * 1e3);
  }
  if (item && ["SELECT", "SELECT_INPUT"].includes(item.type)) {
    if (attribute[0]?.attribute_id === 0) {
      return attribute[0]?.value;
    }
    return attribute[0]?.attribute_id;
  }
  if (item && ["MULTI_SELECT", "MULTI_SELECT_INPUT"].includes(item.type)) {
    return attribute.map((_2) => {
      if (_2.attribute_id === 0) {
        return _2.value;
      }
      return _2.attribute_id;
    });
  }
};
export const BasicInfo = forwardRef((props, ref) => {
  const {formatMessage} = useIntl();
  const {fetchShopsLogisticsMap} = useShopsLogisticsMapModel();
  const {fetchCategoryAttributes, categoryAttributes, mandatoryCategoryAttributes, optionalCategoryAttributes} = useCategoryAttributes();
  const {fetchCategoryRuleChannel, resetCategoryRuleChannel} = useCategoryRuleChannelModel();
  const {fetchShops, shops: shopsRaw, shopsLoading} = useShops();
  const {brands, brandsLoading, fetchBrands, setBrands} = useBrands();
  const {shopCountry, setShopCountry, setShopIds, shopIds, setShops} = useShopCountryModel();
  const {setCatrgoryInfo} = useCatrgoryInfoModel();
  const [selectShops, setSelectShops] = useState([]);
  const shops = useMemo(() => {
    const result = [];
    const temp = ["ID", "PH", "VN", "TH", "MY", "SG"];
    temp.forEach((_2) => {
      result.push(...shopsRaw.filter((shop) => shop.countryCode === _2));
    });
    return result;
  }, [shopsRaw]);
  const [form] = useForm();
  const [data, setData] = useState();
  const [showMore, setShowMore] = useState(false);
  const [descriptionType, setDescriptionType] = useState("normal");
  const loading = useMemo(() => {
    return !!props.loading;
  }, [props.loading]);
  const curData = useMemo(() => {
    if (props.data) {
      return props.data;
    }
    return data;
  }, [data, props.data]);
  const fetchBrandsDebounce = useMemo(() => {
    return debounce((params) => {
      fetchBrands(params);
    }, 800);
  }, []);
  useEffect(() => {
    return () => {
      setShopIds([]);
    };
  }, []);
  const {
    data: attributes,
    run: updateAttributesMap,
    loading: attributesLoading
  } = useRequest((params) => {
    return request.post("/saas/shop/pull-category-attributes", params);
  }, {
    manual: true,
    onFinally: () => {
    }
  });
  const getMaxLengthByCountry = (name, country) => {
    const temp = getRulesByCountry(name, country)[0];
    if (temp) {
      return temp.max;
    }
    return 0;
  };
  const getRulesByCountry = (name, country) => {
    if (name === "productName") {
      if (country === "ID") {
        return [
          {
            min: 5,
            max: 255,
            message: formatMessage({id: "productNameLimitId"})
          }
        ];
      }
      if (country === "PH") {
        return [
          {
            min: 20,
            max: 100,
            message: formatMessage({id: "productNameLimitPh"})
          }
        ];
      }
      if (country === "VN") {
        return [
          {
            min: 10,
            max: 120,
            message: formatMessage({id: "productNameLimitVn"})
          }
        ];
      }
      return [
        {
          min: 20,
          max: 120,
          message: formatMessage({id: "productNameLimitOthers"})
        }
      ];
    }
    if (name === "description") {
      if (country === "ID") {
        return [
          {
            min: 20,
            max: 3e3,
            message: formatMessage({id: "productDescriptionLimitIdMy"})
          }
        ];
      }
      if (country === "PH") {
        return [
          {
            min: 2,
            max: 3e3,
            message: formatMessage({id: "productDescriptionLimitPh"})
          }
        ];
      }
      if (country === "VN") {
        return [
          {
            min: 100,
            max: 3e3,
            message: formatMessage({id: "productDescriptionLimitVn"})
          }
        ];
      }
      if (country === "TH") {
        return [
          {
            min: 25,
            max: 5e3,
            message: formatMessage({id: "productDescriptionLimitTh"})
          }
        ];
      }
      if (country === "MY") {
        return [
          {
            min: 20,
            max: 3e3,
            message: formatMessage({id: "productDescriptionLimitIdMy"})
          }
        ];
      }
      if (country === "SG") {
        return [
          {
            min: 0,
            max: 5e3,
            message: formatMessage({id: "productDescriptionMustBeBetweenMinmaxcharacters"}, {min: 0, max: 5e3})
          }
        ];
      }
    }
    return [];
  };
  const exportDescription = (descriptionType2, value) => {
    let description = "";
    if (descriptionType2 === "normal") {
      description = value;
    } else {
      const regex = /<p\b[^>]*>([\s\S]*?)<\/p>|<img.*?src=['"](.*?)['"].*?>/g;
      const matches = value.match(regex) || [];
      if (matches.length !== 0) {
        matches.forEach((item = "", index) => {
          if (item.startsWith("<p")) {
            let regex2 = /<p[^>]*>(.*?)<\/p>/gi;
            let matches2 = regex2.exec(item);
            if (matches2) {
              const pContent = matches2[1] || "";
              if (pContent) {
                description = description.concat(`<p index='${index}'>${pContent}</p>`);
              }
            }
          } else {
            let imgSrcList = item?.match(/src=['"](.*?)['"]/);
            let imgIdList = item?.match(/id=['"](.*?)['"]/);
            if (imgSrcList) {
              let imgId = imgIdList && imgIdList.length > 1 ? imgIdList[1] : "1";
              let imgSrc = imgSrcList && imgSrcList.length > 1 ? imgSrcList[1] : "";
              description = description.concat(`<img index='${index}' src='${imgSrc}' id='${imgId}'/>`);
            }
          }
        });
      }
    }
    return description;
  };
  useImperativeHandle(ref, () => ({
    submit: async () => {
      try {
        await form.validateFields();
      } catch (error) {
        throw {
          error,
          form
        };
      }
      const values = form.getFieldsValue();
      let tempAttributes = {};
      if (categoryAttributes && categoryAttributes.length) {
        categoryAttributes.map((data2) => {
          if (isArray(values[`${data2.attributeId}.productAttribute`]) && values[`${data2.attributeId}.productAttribute`].length || !isArray(values[`${data2.attributeId}.productAttribute`]) && values[`${data2.attributeId}.productAttribute`]) {
            tempAttributes[data2.attributeId] = getCategoryAttributeValue(data2.attributeId, values[`${data2.attributeId}.productAttribute`], categoryAttributes);
          }
        });
      }
      let descriptionValue = "";
      if (descriptionType === "normal") {
        descriptionValue = exportDescription(descriptionType, values.description ?? "");
      } else {
        descriptionValue = exportDescription(descriptionType, desc ?? "");
      }
      const result = {
        attributes: {...tempAttributes},
        brandId: values.brandId,
        brandName: brands.find((_2) => _2.label === values.brandId)?.value,
        conditionType: values.conditionType || "NEW",
        externalFullCategoryId: values.categoryIds?.join("-"),
        productDangerous: Number(values.productDangerous),
        productName: values.productName,
        shopIds: values.shopIds,
        description: descriptionValue,
        descriptionType
      };
      return result;
    }
  }));
  const shopSelectChange = (value) => {
    if (!value.length) {
      setShopCountry(void 0);
    }
    setSelectShops(value);
    if (value && value[0]) {
      setShopCountry(shops.find((_2) => _2.id === value[0])?.countryCode);
      const multiWarehouse = shops.filter((shop) => {
        return value.includes(shop.id) && shop.multiWarehouse;
      });
      if (multiWarehouse.length === 0) {
        setShopIds([]);
      } else {
        setShopIds(multiWarehouse?.map((item) => item.id));
      }
      setShops(value);
      fetchShopsLogisticsMap(value, shops.filter((_2) => value.includes(_2.id)));
    }
  };
  useEffect(() => {
    if (!curData) {
      return;
    }
    if (!shops.length) {
      return;
    }
    if (!curData.isMultiWarehouse) {
      setShopIds([]);
    }
    setDescriptionType(curData?.descriptionType);
    if (curData?.descriptionType === "extended") {
      curData.extendedDescription = curData.description;
      desc = curData.description;
    }
    let shopCountry2 = "";
    const newFieldsValue = {
      ...curData,
      productDangerous: String(curData.productDangerous),
      categoryIds: curData?.externalFullCategoryId?.length ? curData.externalFullCategoryId.split("-") : []
    };
    if (curData.shopIds && curData.shopIds.length) {
      shopSelectChange(curData.shopIds);
      shopCountry2 = shops.find((_2) => _2.id === curData.shopIds[0])?.countryCode || "";
    }
    form.resetFields();
    form.setFieldsValue(newFieldsValue);
    const categoryId = [...newFieldsValue?.categoryIds].pop();
    setCatrgoryInfo(categoryId);
    let param = {
      countryCode: shopCountry2,
      channel: "SHOPEE_ID",
      categoryId
    };
    categoryId && fetchCategoryAttributes(param);
    setBrands([
      {
        label: curData.brandId,
        value: curData.brandName
      }
    ]);
    categoryId && fetchBrands({
      channel: "SHOPEE_ID",
      country: shopCountry2,
      prefix: "",
      categoryId,
      appendBrands: [
        {
          label: curData.brandId,
          value: curData.brandName
        }
      ]
    });
  }, [curData, shops]);
  useEffect(() => {
    const temp = {};
    if (categoryAttributes && categoryAttributes.length && props?.data?.attributes) {
      categoryAttributes.map((data2) => {
        if (props?.data?.attributes[`${data2.attributeId}`]) {
          temp[`${data2.attributeId}.productAttribute`] = getCategoryAttributeFormValue(data2.attributeId, props?.data?.attributes[`${data2.attributeId}`], categoryAttributes);
        }
      });
      form.setFieldsValue({...temp});
    }
  }, [categoryAttributes]);
  useOnMounted(async () => {
    fetchShops({
      page: 0,
      pageSize: 500
    }, {connectStatus: "CONNECTED", selectedChannel: "SHOPEE_ID"});
    form.setFieldsValue({
      productDangerous: "0",
      conditionType: "NEW"
    });
  });
  const tagRender = (props2) => {
    const {label, value, closable, onClose} = props2;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return /* @__PURE__ */ React.createElement(Tag, {
      color: value,
      onMouseDown: onPreventMouseDown,
      closable,
      onClose,
      style: {marginRight: 3, color: "#333"}
    }, /* @__PURE__ */ React.createElement(TableStoreLogo, {
      size: 16,
      channelName: "Shopee"
    }), label);
  };
  const diyUploadFn = (params) => {
    const fd = new FormData();
    fd.append("file", params.file);
    fd.append("channel", "SHOPEE_ID");
    fd.append("fileType", "PRODUCT_IMAGE");
    const shopId = form.getFieldValue("shopIds");
    fd.append("shopId", shopId[0]);
    request.post("/saas/product/v2/upload/upload-file", fd, {
      onUploadProgress: (event) => {
        params.progress(event.loaded / event.total * 100);
      }
    }).then((data2) => {
      console.log("data:", data2, "params:", params);
      params.success({
        url: data2.fileUrl,
        meta: {
          id: data2.fileId,
          title: params.file.name,
          alt: params.file.name,
          loop: false,
          autoPlay: false,
          controls: false,
          poster: ""
        }
      });
    }).catch((error) => {
      params.error({msg: error.message});
    });
  };
  return /* @__PURE__ */ React.createElement(Wrapper, {
    id: "basicInfo",
    className: "block-info"
  }, /* @__PURE__ */ React.createElement(Collapse, {
    defaultActiveKey: ["1"],
    expandIconPosition: "right",
    expandIcon: ({isActive}) => /* @__PURE__ */ React.createElement(IconDown, {
      style: {
        transition: "all, 0.3s",
        position: "absolute",
        top: 10,
        transform: `rotate(
            ${isActive ? 0 : "-90deg"}
        )`
      }
    })
  }, /* @__PURE__ */ React.createElement(Panel, {
    header: /* @__PURE__ */ React.createElement("div", {
      className: "block-title"
    }, formatMessage({id: "basicInformation"})),
    key: "1"
  }, /* @__PURE__ */ React.createElement(Spin, {
    spinning: loading
  }, /* @__PURE__ */ React.createElement(Form, {
    form,
    layout: "vertical"
  }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    span: "12"
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    shouldUpdate: (prevValues, currentValues) => prevValues.shopIds !== currentValues.shopIds,
    noStyle: true
  }, ({getFieldValue}) => {
    return /* @__PURE__ */ React.createElement(Form.Item, {
      label: /* @__PURE__ */ React.createElement(React.Fragment, null, formatMessage({id: "onSaleShop"}), /* @__PURE__ */ React.createElement(Tip, {
        tip: formatMessage({
          id: "supportSelectingMultipleStoresInThe"
        })
      })),
      name: "shopIds",
      rules: [
        {
          required: true,
          message: formatMessage({id: "pleaseChoose"})
        }
      ]
    }, /* @__PURE__ */ React.createElement(Select, {
      style: {width: "100%"},
      className: "shops-select",
      allowClear: true,
      mode: "multiple",
      getPopupContainer: (triggerNode) => triggerNode.parentNode,
      maxTagTextLength: 10,
      disabled: !!props.data,
      tagRender,
      maxTagCount: 2,
      placeholder: formatMessage({
        id: "onSaleShop"
      }),
      optionLabelProp: "title",
      optionFilterProp: "title",
      loading: shopsLoading,
      onChange: shopSelectChange
    }, shops && Object.values(shops).map((item) => /* @__PURE__ */ React.createElement(Option, {
      value: item.id,
      key: item.id,
      title: item.shopName,
      disabled: !!shopCountry && item.countryCode !== shopCountry
    }, /* @__PURE__ */ React.createElement("div", {
      style: {
        display: "flex",
        flexWrap: "nowrap"
      }
    }, /* @__PURE__ */ React.createElement("span", {
      role: "img",
      style: {marginRight: 4}
    }, /* @__PURE__ */ React.createElement("img", {
      src: getFieldValue("shopIds") && getFieldValue("shopIds").includes(item.id) ? checked : unchecked,
      className: "select-checkbox"
    })), /* @__PURE__ */ React.createElement(TableStore, {
      size: 16,
      channelName: item.channelName,
      shopName: item.shopName,
      countryCode: item.countryCode
    }))))));
  }), selectShops?.length > 1 && /* @__PURE__ */ React.createElement("span", {
    style: {position: "relative", top: "-10px", color: "#F49342"}
  }, formatMessage({id: "whenSelectingMultipleShopeeStoresThe"})))), /* @__PURE__ */ React.createElement(Row, {
    style: {display: shopCountry ? "block" : "none"}
  }, /* @__PURE__ */ React.createElement(Col, {
    span: "12"
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    label: /* @__PURE__ */ React.createElement(React.Fragment, null, formatMessage({id: "productName"}), /* @__PURE__ */ React.createElement(Tip, {
      tip: formatMessage({
        id: "theMaximumRangeAccordingToApi"
      })
    })),
    name: "productName",
    rules: [
      ["DRAFT", "PUBLISH"].includes(props.status) ? {
        required: true,
        message: formatMessage({id: "pleaseEnter"})
      } : {required: false},
      ...getRulesByCountry("productName", shopCountry)
    ]
  }, /* @__PURE__ */ React.createElement(InputLimit, {
    maxLength: getMaxLengthByCountry("productName", shopCountry),
    disabled: !shopCountry,
    limit: getMaxLengthByCountry("productName", shopCountry),
    inputProps: {
      placeholder: formatMessage({id: "pleaseEnter"})
    },
    onBlur: () => {
      form.setFieldsValue({
        productName: form.getFieldValue("productName")?.trim()
      });
    }
  })))), /* @__PURE__ */ React.createElement(Row, {
    style: {display: shopCountry ? "block" : "none"}
  }, /* @__PURE__ */ React.createElement(Col, {
    span: "12"
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    label: /* @__PURE__ */ React.createElement(React.Fragment, null, formatMessage({id: "category"}), /* @__PURE__ */ React.createElement(SyncButton, {
      getSyncData: () => {
        const categoryId = [...form.getFieldValue("categoryIds") || []].pop();
        const shopIds2 = form.getFieldValue("shopIds") || [];
        if (!categoryId || !shopIds2) {
          return false;
        }
        updateAttributesMap({
          channel: "SHOPEE_ID",
          shopIdList: shopIds2,
          externalCategoryId: categoryId
        });
      },
      style: {top: 0},
      isLoading: attributesLoading
    })),
    name: "categoryIds",
    rules: [
      ["PUBLISH"].includes(props.status) ? {
        required: true,
        message: formatMessage({id: "pleaseSelect"})
      } : {required: false}
    ]
  }, /* @__PURE__ */ React.createElement(CascaderWrapper, {
    id: "categoryIds",
    countryCode: shopCountry,
    onChange: (val) => {
      form.setFieldsValue({
        brandId: void 0
      });
      setCatrgoryInfo(val && [...val]?.pop());
      if (!val || !val.length) {
        resetCategoryRuleChannel();
        return;
      }
      let param = {
        countryCode: shopCountry,
        channel: "SHOPEE_ID",
        categoryId: [...val].pop()
      };
      fetchCategoryAttributes(param);
      fetchCategoryRuleChannel(param);
      fetchBrands({
        channel: "SHOPEE_ID",
        country: shopCountry,
        prefix: "",
        categoryId: [...val].pop()
      });
    }
  })))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    span: "12"
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    shouldUpdate: true,
    noStyle: true
  }, () => {
    const categoryId = [...form.getFieldValue("categoryIds") || []].pop();
    return /* @__PURE__ */ React.createElement(Form.Item, {
      style: {display: categoryId ? "block" : "none"},
      label: formatMessage({id: "brand"}),
      name: "brandId",
      rules: [
        ["PUBLISH"].includes(props.status) ? {
          required: true,
          message: formatMessage({
            id: "pleaseSelect"
          })
        } : {required: false}
      ]
    }, /* @__PURE__ */ React.createElement(Select, {
      disabled: !categoryId,
      placeholder: formatMessage({id: "pleaseSelect"}),
      loading: brandsLoading,
      showSearch: true,
      filterOption: false,
      onSearch: (val) => {
        fetchBrandsDebounce({
          channel: "SHOPEE_ID",
          country: shopCountry,
          prefix: val,
          categoryId
        });
      }
    }, brands.map((_2) => {
      if (_2.label === "0") {
        return /* @__PURE__ */ React.createElement(Option, {
          key: "0",
          value: "0",
          title: formatMessage({id: "NoBrand"})
        }, formatMessage({id: "NoBrand"}));
      }
      return /* @__PURE__ */ React.createElement(Option, {
        key: _2.label,
        value: _2.label,
        title: _2.value
      }, _2.value);
    })));
  }))), descriptionType === "normal" ? /* @__PURE__ */ React.createElement(Row, {
    style: {display: shopCountry ? "block" : "none"}
  }, /* @__PURE__ */ React.createElement(Col, {
    span: "12"
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    label: /* @__PURE__ */ React.createElement(React.Fragment, null, formatMessage({id: "DetailProductDescription"}), /* @__PURE__ */ React.createElement(Switch, {
      checked: descriptionType === "extended",
      size: "small",
      onChange: (checked2) => {
        setDescriptionType(checked2 ? "extended" : "normal");
      },
      style: {marginLeft: "10px"}
    }), formatMessage({id: "enableLongDescription"}), /* @__PURE__ */ React.createElement(Tip, {
      tip: formatMessage({
        id: "myShopeeSellerCenterCanInsert"
      })
    })),
    name: "description",
    rules: [
      ["PUBLISH"].includes(props.status) ? {
        required: true,
        message: formatMessage({
          id: "pleaseEnter"
        })
      } : {required: false},
      ...getRulesByCountry("description", shopCountry)
    ]
  }, /* @__PURE__ */ React.createElement(TextArea, {
    disabled: !shopCountry,
    rows: 6,
    maxLength: getMaxLengthByCountry("description", shopCountry),
    placeholder: formatMessage({
      id: "productDescription"
    }),
    showCount: {
      formatter: ({count, maxLength}) => {
        return `${count}/${getMaxLengthByCountry("description", shopCountry)}`;
      }
    }
  })))) : /* @__PURE__ */ React.createElement(Row, {
    style: {display: shopCountry ? "block" : "none"}
  }, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(Form.Item, {
    label: /* @__PURE__ */ React.createElement(React.Fragment, null, formatMessage({id: "DetailProductDescription"}), /* @__PURE__ */ React.createElement(Switch, {
      checked: descriptionType === "extended",
      size: "small",
      onChange: (checked2) => {
        setDescriptionType(checked2 ? "extended" : "normal");
      },
      style: {marginLeft: "10px"}
    }), formatMessage({id: "enableLongDescription"}), /* @__PURE__ */ React.createElement(Tip, {
      tip: formatMessage({
        id: "myShopeeSellerCenterCanInsert"
      })
    })),
    name: "extendedDescription",
    rules: [
      ["PUBLISH"].includes(props.status) ? {
        required: true,
        message: formatMessage({
          id: "pleaseEnter"
        })
      } : {required: false},
      ...getRulesByCountry("description", shopCountry)
    ]
  }, /* @__PURE__ */ React.createElement(RichTextEditor, {
    wrapperStyle: {
      border: "1px solid #e5e7eb",
      backgroundColor: "#fcfcfc",
      width: "100%",
      maxWidth: 1e3
    },
    controls: ["media"],
    media: {uploadFn: diyUploadFn},
    contentStyle: {height: 300},
    placeholder: formatMessage({id: "pleaseEnter"}),
    onChange: (value) => {
      desc = value;
    },
    extendControls: [
      {
        key: "preview",
        type: "component",
        component: /* @__PURE__ */ React.createElement(RichTextEditor.Preview, null)
      }
    ]
  })))), ["ID", "MY"].includes(shopCountry || "") && /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    span: "12"
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    label: /* @__PURE__ */ React.createElement(React.Fragment, null, formatMessage({id: "dangerousGoods"}), /* @__PURE__ */ React.createElement(Tip, {
      tip: formatMessage({
        id: "dangerousGoodsTip"
      })
    })),
    name: "productDangerous",
    rules: [
      {
        message: formatMessage({id: "pleaseSelect"})
      }
    ]
  }, /* @__PURE__ */ React.createElement(Radio.Group, null, /* @__PURE__ */ React.createElement(Radio, {
    value: "0"
  }, formatMessage({id: "no"})), /* @__PURE__ */ React.createElement(Radio, {
    value: "1"
  }, formatMessage({id: "dangerousGoodsOption"})))))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    span: "12"
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    label: formatMessage({id: "condition"}),
    name: "conditionType",
    rules: [
      {
        message: formatMessage({id: "pleaseSelect"})
      }
    ]
  }, /* @__PURE__ */ React.createElement(Select, {
    allowClear: true,
    placeholder: formatMessage({
      id: "pleaseSelect"
    })
  }, /* @__PURE__ */ React.createElement(Option, {
    value: "NEW"
  }, formatMessage({id: "new"})), /* @__PURE__ */ React.createElement(Option, {
    value: "USED"
  }, formatMessage({id: "used"})))))), mandatoryCategoryAttributes.length ? mandatoryCategoryAttributes.map((data2, index) => dyItemsRender(data2, formatMessage)) : "", /* @__PURE__ */ React.createElement("div", {
    style: {
      display: !showMore && !!optionalCategoryAttributes.length ? "block" : "none"
    },
    className: "view-more-box",
    onClick: () => {
      setShowMore(true);
    }
  }, /* @__PURE__ */ React.createElement("img", {
    src: viewMoreSvg
  }), formatMessage({id: "viewMore"})), /* @__PURE__ */ React.createElement("div", {
    style: {
      display: showMore ? "block" : "none"
    }
  }, optionalCategoryAttributes.length ? optionalCategoryAttributes.map((data2, index) => dyItemsRender(data2, formatMessage)) : "", /* @__PURE__ */ React.createElement("div", {
    className: "view-more-box",
    onClick: () => {
      setShowMore(false);
    }
  }, /* @__PURE__ */ React.createElement("img", {
    style: {
      transform: "rotate(180deg)"
    },
    src: viewMoreSvg
  }), formatMessage({id: "viewLess"}))))))));
});
const Wrapper = styled.div`
  &.block-info {
    background: #ffffff;
  }
  .view-more-box {
    height: 33px;
    background: #f5f7fa;
    margin: 16px auto;
    font-size: 13px;
    color: #6020ff;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 24px;
      height: 24px;
    }
  }
  .suffix-append {
    position: absolute;
    display: inline-block;
    bottom: -15px;
    right: 5px;
    opacity: 0.5;
    z-index: 3;
    margin: 20px 0;
  }
  .block-title {
    font-size: 14px;
    font-family: SFProText-Medium, SFProText;
    font-weight: 500;
    color: #161344;
    line-height: 20px;
  }
  .block-input-group {
    display: flex;
    .ant-input-number {
      flex: 1;
    }
    .ant-input-number-handler-wrap {
      display: none;
    }
  }
  .block-input-group-handler {
    .ant-input-number-handler-wrap {
      display: block;
      opacity: 1;
    }
  }
  .ant-collapse {
    border: 1px solid #dfe3e8;
    background: #fff;
    border-radius: 0;
  }
  .ant-collapse > .ant-collapse-item {
    border-bottom: 0;
  }
  .ant-collapse-content {
    border-top: 1px solid #dfe3e8;
    overflow: inherit;
  }
  .ant-input-textarea textarea {
    min-height: 118px;
  }
  .ant-input-textarea-show-count:after {
    margin-top: 8px;
    font-size: 10px;
    font-family: SFProText-Regular, SFProText;
    font-weight: 400;
    color: #7f8fa4;
    line-height: 12px;
  }
  .ant-form-item {
    margin-bottom: 16px;
  }
  .shops-select {
    .ant-select-selection__choice__content {
      .select-checkbox {
        display: none !important;
      }
    }
    .select-checkbox {
      width: 14px;
      height: 14px;
      position: relative;
      top: -1px;
    }
    .ant-select-selector {
      border-radius: 3px 0 0 3px !important;
    }
  }
  .ant-select-selection-overflow {
    position: relative;
    display: flex;
    flex: auto;
    flex-wrap: wrap;
    max-width: 100%;
  }
`;
